export default {
  components: {
    onboardingWidget: {
      container: 'dt.commissioner.components.onboardingWidget.container',
      noContests: {
        title: 'dt.commissioner.components.onboardingWidget.noContests.title',
        description: 'dt.commissioner.components.onboardingWidget.noContests.description',
        createMyFirstContest:
          'dt.commissioner.components.onboardingWidget.noContests.createMyFirstContest',
        learnMore: 'dt.commissioner.components.onboardingWidget.noContests.learnMore',
      },
    },
  },
};
